export default function Preporucuje() {
    return (
        <div className="absolute right-5 top-5 bg-green-custom p-2 px-3 rounded">
            <span className="text-xs pr-2" style={{ color: "#36930d" }}>
                preporučuje
            </span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="inline h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#36930d"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
            </svg>
        </div>
    );
}
